import { Card, CardContent } from "ui/components/card";

import { ADD_USER, USER } from "icons";
import AvatarDisplay from "components/avatar/display";
import { Badge } from "ui/components/badge";
import Icon from "components/icon";
import classNames from "classnames";
import { cn } from "utils";
import { Shimmer } from "components/shimmer";

export function EvtClientLoaderCard() {
    return (
        <Card className={classNames("h-max")}>
            <CardContent>
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4 relative">
                    <div className="size-10 bg-secondary rounded-full flex place-items-center place-content-center">
                        <Icon className="size-4 text-neutral-500" icon={USER} />
                    </div>

                    <div className="space-y-0.5">
                        <Shimmer className="w-40 h-6" />
                        <Shimmer className="w-20 h-3" />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}